<template>
  <div class="mouseActionContainer" :class="{ isDark: isDark }">
    <a-tooltip
      class="item"
      effect="dark"
      :title="
        useLeftKeySelectionRightKeyDrag
          ? '当前：左键拖动画布，右键框选节点'
          : '当前：左键框选节点，右键拖动画布'
      "
      placement="top"
    >
      <div
        class="btn iconfont"
        :class="[useLeftKeySelectionRightKeyDrag ? 'iconmouseR' : 'iconmouseL']"
        @click="toggleAction"
      /></a-tooltip>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'MouseAction',
  props: {
    mindMap: {
      type: Object
    },
    isDark: {
      type: Boolean
    }
  },
  data() {
    return {};
  },
  computed: {
    useLeftKeySelectionRightKeyDrag() {
      if (this.mindMap) {
        return this.mindMap.getConfig('useLeftKeySelectionRightKeyDrag');
      }
      return false;
    }
  },
  methods: {
    ...mapMutations(['setLocalConfig']),

    toggleAction() {
      const val = !this.useLeftKeySelectionRightKeyDrag;
      this.mindMap.updateConfig({
        useLeftKeySelectionRightKeyDrag: val
      });
      this.setLocalConfig({
        useLeftKeySelectionRightKeyDrag: val
      });
    }
  }
};
</script>

<style lang="less" scoped>
.mouseActionContainer {
  display: flex;
  align-items: center;

  &.isDark{
    .btn {
      color: hsla(0,0%,100%,.6);
    }
  }

  .item {
    margin-right: 12px;

    &:last-of-type {
      margin-right: 0;
    }
  }

  .btn {
    cursor: pointer;
    font-size: 18px;
  }
}
</style>
